var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 0H1.00001C0.447719 0 0 0.447719 0 1.00001V13.0001C0 13.5524 0.447719 14.0001 1.00001 14.0001H10.0001C10.5524 14.0001 11.0001 13.5524 11.0001 13.0001V1.00001C11.0001 0.447719 10.5524 0 10.0001 0Z",
    fill: "#5B5BD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.49957 2H2.49952C2.22337 2 1.99951 2.22386 1.99951 2.5V5.50003C1.99951 5.77617 2.22337 6.00003 2.49952 6.00003H8.49957C8.77571 6.00003 8.99957 5.77617 8.99957 5.50003V2.5C8.99957 2.22386 8.77571 2 8.49957 2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.99951H14V5.99954H16V9.99957",
    stroke: "#5B5BD6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 9.5H14.9995C14.7234 9.5 14.4995 9.72386 14.4995 10V11C14.4995 11.2762 14.7234 11.5 14.9995 11.5H16.4995C16.7757 11.5 16.9995 11.2762 16.9995 11V10C16.9995 9.72386 16.7757 9.5 16.4995 9.5Z",
    fill: "#5B5BD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.891dc78e.svg";
export { ForwardRef as ReactComponent };